import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from "../src/Pages/Home";
import Leaderboard from "../src/Pages/Leaderboard";

function App() {

	return (
		<div>
			<BrowserRouter>
				<Routes>

					<Route path='/' element={<Home />} />
					<Route path='/leaderboard' element={<Leaderboard />} />

				</Routes>
			</BrowserRouter>

		</div>

	)
}

export default App;
